export const QOUTES_ICON_TEXT = "Qoutes Icon";
